// // Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getAuth} from "firebase/auth"
// import { getAnalytics } from "firebase/analytics";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCqmpDsimROzB_ed5Tv6DHFqIkoul5OFlg",
  authDomain: "koreanlearningapp-d35d6.firebaseapp.com",
  databaseURL: "https://koreanlearningapp-d35d6-default-rtdb.firebaseio.com",
  projectId: "koreanlearningapp-d35d6",
  storageBucket: "koreanlearningapp-d35d6.firebasestorage.app",
  messagingSenderId: "282701188243",
  appId: "1:282701188243:web:a9bba3bb8b96c21c1fd166",
  measurementId: "G-7DSX7GHGQK"
};

// // Initialize Firebase
export const FIREBASE_APP = initializeApp(firebaseConfig);
export const FIREBASE_AUTH = getAuth(FIREBASE_APP);